import accessController from './access.controller';

export default angular
  .module('st.Access', ['st.Core', 'angular-cache'])
  .controller('accessController', accessController)
  .service('accessService', ($http, $rootScope, dataService, uiService, ACCESS) => ({
    refer: (params) =>
      dataService
        .apiRequest(null, null, true, null, $http.get, ACCESS.API.REFER, {
          params
        })
        .then((res) => {
          if (res && res.status) {
            uiService.toast({
              text: {
                p1: 'Deal',
                p2: 'referred',
                p3: 'successfully'
              }
            });
          } else {
            uiService.toast({
              text: {
                p1: 'Deal',
                p2: 'referral',
                p3: 'has failed'
              },
              warn: true
            });
          }
        }),
    updateAccess: (a) => {
      if (a) {
        const idx = _.findIndex($rootScope.CurrentOrganization.access, (ac) => ac.id === a.id);
        if (idx >= 0) {
          $rootScope.CurrentOrganization.access[idx] = a;
        } else {
          $rootScope.CurrentOrganization.access.push(a);
        }
      }
    },
    deleteAccess: (a) => {
      $rootScope.CurrentOrganization.access.splice(
        _.findIndex($rootScope.CurrentOrganization.access, (ac) => ac.id === a.id),
        1
      );
    },
    getOutbound: (idWorkflow, idStage) =>
      _.sortBy(
        _.filter(
          $rootScope.CurrentOrganization.access,
          (a) =>
            a.isOutbound === true &&
            (!a.idWorkflow || a.idWorkflow === idWorkflow) &&
            (!a.idStage || a.idStage === idStage)
        ),
        'name'
      ),
    getInbound: (idWorkflow, idStage) =>
      _.sortBy(
        _.filter(
          $rootScope.CurrentOrganization.access,
          (a) =>
            a.isOutbound === false &&
            (!a.idWorkflow || a.idWorkflow === idWorkflow) &&
            (!a.idStage || a.idStage === idStage)
        ),
        'name'
      )
  }))
  .constant('ACCESS', {
    API: {
      REFER: '/api/v1/access/refer/'
    }
  });
